// ヘッダーナビゲーション（ハンバーガーメニュー）

function setupHeaderNav() {
  const $btn = $('.js-nav-btn');
  const $nav = $('#nav');

  function openNav() {
    $nav.addClass('is-open').attr('aria-hidden', 'false');
    $btn.addClass('is-open').attr('aria-expanded', 'true');
  }

  function closeNav() {
    $nav.removeClass('is-open').attr('aria-hidden', 'true');
    $btn.removeClass('is-open').attr('aria-expanded', 'false');
  }

  $btn.on('click', function () {
    if ($nav.hasClass('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  $nav.on('click', '.nav_bg, .js-nav-link', function () {
    closeNav();
  });
}

function setupSideNav() {
  const $nav = $('.js-side-nav');
  if (!$nav.length) return;

  const $mv = $('.js-mv');

  function update() {
    if (!window.matchMedia('(min-width: 1200px)').matches) {
      $nav.removeClass('is-show');
      return;
    }
    // 下層など MV がないページは常時表示
    if (!$mv.length) {
      $nav.addClass('is-show');
      return;
    }
    const mvBottom = $mv.offset().top + $mv.outerHeight();
    $nav.toggleClass('is-show', $(window).scrollTop() + 100 >= mvBottom);
  }

  $(window).on('load scroll resize', update);
  update();
}

function setupAccordions() {
  $('.js-acc-btn').on('click', function () {
    const $btn = $(this);
    const $body = $btn.next('.js-acc-body');
    const $plus = $btn.find('.accBtn__plus');
    $btn.toggleClass('is-open');
    $plus.text($btn.hasClass('is-open') ? '−' : '＋');
    $body.stop(true, true).slideToggle(280).toggleClass('is-open');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupHeaderNav();
  setupSideNav();
  setupAccordions();
});
